export const cn = {
  Navbar: {
    about_TOEIC: '测验简介',
    must_know_vocabulary: '必考单字',
    ai_helper: 'AI 小助教'
  },
  Overview: {
    classify: '学前测验',
    time: '学习总时数',
    course: '通过课程数',
    practice: '通过课后挑战',
    exam: '完成月考数',
    exam_score: '月考分数',
    exam_advance: '任一月考>学前测验',
    exam_advance_with_percent: '月考进步百分比',
    writing_count: '完成写作篇数'
  },
  Login: {
    register: '我要报名',
    trial: '申请试用',
    login: '登入',
    log_out: '登出',
    start_my_course: '登入学习',
    please_enter_your_email: '请输入电子信箱...',
    please_enter_password: '请输入密码...'
  },
  Home: {
    Daily_English: '每日一句',
    World_News: '全球新闻',
    Lets_play_in_English: '英文好好玩',
    FunEnglish: '跟着老师一起，玩游戏、学单字、培养英语语感力!',
    Learning_History: '近期学习课程',
    Latest_Courses: '最新课程',
    Recommend: '推荐课程',
    Learning_Guides: '学习指引',
    Go_to_course: '前往课程',
    Play: '播放音档',
    Keep: '收藏',
    watch_more: '看更多'
  },
  AI: {
    Home: {
      myPoints: '我的点数',
      pointUnit: '点',
      viewUsageRecords: '查看使用记录',
      geptBeginner: 'GEPT初级',
      geptIntermediate: 'GEPT中级',
      pastExamQuestions: '历届考古题',
      mockTest: '模拟试题',
      letterGenerator: '书信生成',
      aiCorrection: 'AI批改',
      speechScriptGenerator: '演讲稿生成',
      shadowingPractice: '跟读练习',
      noAiPointsDeducted: '(不扣点)',
      guide: '使用指南',
      generateLetter: '生成书信',
      generateSpeech: '生成演讲稿',
      businessScenario: '商业情境',
      lifeScenario: '生活情境'
    },
    Records: {
      backToAIHelper: '返回AI小助教',
      serialNumber: '序号',
      usageTime: '使用时间',
      item: '项目',
      pointsDeducted: '扣除点数',
      goTo: '前往',
      noUsageRecords: '尚无使用记录',
      redeemConfirmTitle: '确认兑换AI英语学习教室 {points}点?',
      currentTotalPoints: '目前总点数：',
      addPoints: '增加 {points} 点',
      pointsAfterRedeem: '增加后点数',
      confirm: '确认',
      cancel: '取消',
      errorOccurred: '发生错误',
      redeemComplete: '兑换完成',
      redeemFailed: '兑换失败',
      redeemConfirmation: '兑换确认'
    }
  },
  GEPT: {
    common: {
      geptPractice: 'GEPT 模拟练习',
      quizWriting: '学测写作',
      points: '点',
      logout: '登出',
      practiceOverview: '练习总览',
      roundOverview: '回数总览',
      beginnerAndIntermediate: '初级与中级',
      mockAndPast: '模拟试题与历届考古题',
      speakingAndWriting: '口说与写作',
      speaking: '口说',
      writing: '写作',
      speakingPractice: '口说练习',
      writingPractice: '写作练习',
      practiceCount: '练习次数',
      notStarted: '尚未开始练习',
      expiredRedeemAgain: '有效期已过，请重新扣点',
      validTime: '有效时间：{date}',
      noRecord: '尚无纪录',
      viewRecord: '查看纪录',
      startPractice: '开始练习',
      enterPractice: '进入练习',
      selectPracticeItem: '请选择要练习的项目',
      question: '题目',
      answer: '回答',
      start: 'START',
      nextQuestion: '下一题',
      nextType: '前往下一个题型',
      submitReport: '交卷看报告',
      confirm: '确认',
      back: '返回',
      notice: 'Notice',
      errorOccurred: '发生错误',
      noExamRecord: '无法取得考试纪录，请稍后再试',
      wordsCount: '已输入 {count} 个单字',
      inputWords: '作答字数：{count} 字',
      wordUnit: '字',
      scoreUnit: '分',
      noAnswer: '尚无作答内容',
      correction: '批改',
      aiCorrection: 'AI批改',
      downloadReport: '下载报告',
      totalScore: '总分',
      referenceAnswer: '参考答案',
      chineseTranslation: '中文翻译：'
    },
    labels: {
      beginner: '初级',
      intermediate: '中级',
      mockExam: '模拟试题',
      pastExam: '历届考古题',
      allQuestions: '全部题目',
      repeat: '复诵',
      readSentences: '朗读句子与短文',
      answerQuestion: '回答问题',
      describeImage: '描述图片',
      readPassage: '朗读短文',
      describePicture: '看图叙述',
      singleSentenceWriting: '单句写作',
      paragraphWriting: '段落写作',
      chineseToEnglish: '中译英',
      englishComposition: '英文作文',
      sentenceRewrite: '句子改写',
      sentenceMerge: '句子合并',
      sentenceReorder: '句子重组',
      pictureWriting: '看图表写作',
      firstPart: '第一部分',
      secondPart: '第二部分',
      thirdPart: '第三部分',
      fourthPart: '第四部分',
      fifthPart: '第五部分',
      sixthPart: '第六部分',
      partWithNumber: '第{number}部分'
    },
    alerts: {
      answerHint: '作答提示',
      unfinishedSentence: '<p>尚有句子未完成</p>',
      scoreFailedTitle: '成绩计算失败',
      scoreFailedText: '请稍后再试或联系客服',
      confirmCompleteTitle: '确认完成 {name} {type} 题型练习?',
      aiCorrectionDesc: '按下确认键后，请稍待片刻由AI英语小助教立即为您进行AI批改。',
      currentTotalPoints: '目前总点数 {points} 点',
      pointsToDeduct: '需扣除 {points} 点',
      pointsAfterDeduct: '扣除后点数 {points} 点',
      calculatingScore: '成绩计算中......',
      leaveTitle: '提醒',
      leaveText: '考试尚未完成，现在离开考试，作答不会送出产生记录，请确认是否中断本次考试。',
      continueAnswering: '继续作答',
      confirmLeave: '确认前往',
      pointNotice: '扣点说明',
      askStart: '请问是否要开始',
      deductAfterConfirm: '按下确认后，将扣除{points}点。',
      currentTotalLabel: '目前总点数：',
      pointsToDeductLabel: '需扣除：',
      pointsAfterDeductLabel: '扣除后点数：',
      insufficientPoints: '点数余额不足',
      insufficientPointsDesc: '点数余额不足支付本课程，请于LiveABC官网加购',
      purchaseUrl: '购买网址'
    },
    speaking: {
      clickToPlayQuestion: '点选后开始播放题目',
      playFinished: '播放完毕',
      listenCarefully: '请仔细聆听',
      answerAfterQuestion: '问题播完后，<br>麦克风将会开启录音，<br>请在时间内回答完成。',
      pleaseAnswerQuestion: '请回答问题',
      recordingFinished: '录音完毕',
      confirmRecording: '确认录制',
      recordingSuccess: '录制成功',
      recordedNext: '确认已录制，<br>前往下一题。',
      skipCountdown: '跳过倒数，开始作答',
      beginnerReadHint: '倒数60秒时，请先阅读题目，<br>在时间内将全部朗读完成。',
      readHint: '请先阅读题目，阅读时间结束倒数时，麦克风将会自动开启录音，请在时间内回答完成。',
      recordingComplete: '录音完成',
      timeUpSubmit: '作答时间已到，请交卷',
      recordingItem: '正在录制 S{number}',
      stopAfterReading: '念完请点选停止键。'
    },
    writing: {
      rewriteInstruction: '请依题目之提示，将原句改写成指定型式，并将改写的句子完整地写在答案卷上（包括提示之文字及标点符号）。',
      placeholderAnswer: '请作答 ...',
      sectionTitle: '第{label}部分　{name}',
      uploadImage: '上传图片',
      questionTitle: '题目',
      clearAnswer: '清除作答框',
      translateDescription: '请将以下中文句子翻译成正确、通顺、达意的英文。',
      compositionDescription: '请依提示写一篇英文作文，文长至少120个单词。',
      paragraphDescription: '请根据以下的图片写一篇约50字的短文。\n注意：未依提示作答者，将予扣分。',
      paragraphHint: '【段落写作】这个部分的写作采整体式的评分再转换成百分制，需要花费的时间跟分数比重都较多，需要阅读提示的文字用英文描写出图片情节约50字的短文，评分的重点包含文字表达完整度、文法、拼字、大小写、标点符号等。<br/><br/>文章第一句可先说明全文主旨，接着内容依照时间顺序描写、切记不要离题或加入不相关的内容，中间善用转折词能让文章结构更为清楚，最后结论可以加入自己对这件事的看法或感受。 试着用关键字先描述图片中的动作或情节，注意时态是过去式或是现在式并且把3张图片都串联起来，把各个句子连接起来之后，要再注意文法上有没有使用错误尤其是动词时态、名词单复数。'
    },
    testing: {
      audioPlayTest: '音档播放测试',
      audioPlayDesc: '请点选播放后，确认声音播放是否正常。',
      micTest: '麦克风测试',
      micDesc: '请对着麦克风说话，线条产生波动，代表麦克风正常。',
      inputTest: '输入测试',
      inputPlaceholder: '点此输入......',
      inputDesc: '请在框内输入英文，确认设备与输入法有正常运作。'
    },
    precautions: {
      beginnerSingleSentenceWriting: '本测验包含两部分：单句写作、段落写作。其中，单句写作又分为「句子改写、句子合并、句子重组」三个大题。<br/>测验时间为40分钟。请点选下方「START」开始进行测验。',
      beginnerParagraphWriting: '本测验包含两部分：单句写作、段落写作。其中，段落写作是根据题目说明以及提供的三格图片写一篇约50字的短文。<br/>测验时间为40分钟。请点选下方「START」开始进行测验。',
      beginnerRepeat: '本测验包含三个部分：「复诵、朗读句子与短文、回答问题」。其中，第一部分复诵共五题，题目由耳机播出，每题播出两次，两次之间大约有一至两秒的间隔。听完两次后，请马上复诵一次。<br/>测验时间共约10分钟。请点选下方「START」开始进行测验。',
      beginnerReadSentences: '本测验包含三个部分：「复诵、朗读句子与短文、回答问题」。其中，第二部分朗读句子与短文共有五个句子及一篇短文，请利用一分钟的时间阅读题目的句子与短文，然后在一分钟内以正常的速度，清楚、正确地朗读一遍，阅读时请不要发出声音。<br/>测验时间共约10分钟。请点选下方「START」开始进行测验。',
      beginnerAnswerQuestion: '本测验包含三个部分：「复诵、朗读句子与短文、回答问题」。其中，第三部分回答问题共七题。题目由耳机播出，每题播出两次，两次之间大约有一至两秒的间隔。听完两次后，请马上回答；每题回答时间为15秒。<br/>测验时间共约10分钟。请点选下方「START」开始进行测验。',
      intermediateChineseToEnglish: '本测验共有两部分。第一部分为「中译英」，第二部分为「英文作文」。<br/>测验时间为40分钟。请点选下方「START」开始进行测验。',
      intermediateEnglishComposition: '本测验共有两部分。第一部分为「中译英」，第二部分为「英文作文」。<br/>测验时间为40分钟。请点选下方「START」开始进行测验。',
      intermediateReadPassage: '本测验包含三个部分：「朗读短文、回答问题、看图叙述」。其中，第一部分朗读短文，请先利用一分钟的时间阅读题目短文，然后在两分钟内以正常的速度，清楚、正确地读出题目短文，阅读时请不要发出声音。<br/>测验时间共约10分钟。请点选下方「START」开始进行测验。',
      intermediateAnswerQuestion: '本测验包含三个部分：「朗读短文、回答问题、看图叙述」。其中，第二部分回答问题共十题。题目已事先录音，每题经由耳机播出两次。第一至五题，每题回答时间15秒；第六至十题，每题回答时间30秒。每题播出后，请立即回答。<br/>测验时间共约10分钟。请点选下方「START」开始进行测验。',
      intermediateDescribePicture: '本测验包含三个部分：「朗读短文、回答问题、看图叙述」。其中，第三部分看图叙述，题目包含一张图片及四个相关的问题，请在一分半钟内完成作答。<br/>测验时间共约10分钟。请点选下方「START」开始进行测验。'
    },
    report: {
      answerReport: '作答报告',
      excellent: '很棒',
      acceptable: '尚可',
      needsImprovement: '待加强',
      subtest: '分项测验',
      scoringCriteria: '评分项目',
      score: '得分',
      scoringSection: '评分部分',
      questionType: '测验题型',
      summaryHeaderIntermediate: ['分项测验', '评分项目', '得分'],
      summaryHeaderSpeaking: ['评分项目', '评分部分', '得分'],
      summaryHeaderWriting: ['评分部分', '测验题型', '得分'],
      translationGroup: '第一部分：中译英（40%）',
      compositionGroup: '第二部分：英文作文（60%）',
      translationCriteria: '用字遣词、文法、拼字、标点符号及大小写',
      compositionCriteria: '内容适切性、组织、字汇及句型、文法、拼字及标点符号',
      singleSentenceGroup: '第一部分:单句写作(50%)',
      paragraphGroup: '第二部分:段落写作(50%)',
      sentenceRewriteType: 'A.句子改写',
      sentenceMergeType: 'B.句子合并',
      sentenceOrderType: 'C.重组',
      pictureWritingType: 'D.看图表写作',
      speakingAllParts: '第一、二、三部分',
      speakingThirdPart: '第三部分',
      pronunciationCriteria: '发音、语调、流利度',
      grammarVocabularyCriteria: '文法、字汇之正确性和适切性',
      speakingFormula: 'GEPT官方网站分数计算公式：百分制总分之计算：（{a}+{b}）×10分﹦{score}分',
      speakingFormulaDefault: 'GEPT官方网站分数计算公式：百分制总分之计算：（A+B）×10分',
      intermediateWritingFormula: 'GEPT官方网站分数计算公式：【(第一部分之级分)×20分×40%】＋【(第二部分之级分)×20分×60%】',
      elementaryWritingFormula: 'GEPT官方网站分数计算公式：（（第一部分得分/30） + （第二部分得分/5））×50',
      previousType: '前往{type}',
      restartType: '此题型重新作答'
    },
    modal: {
      grading: '正在批改...',
      comprehensiveAdvice: '综合建议',
      paragraphStructure: '段落架构：',
      structureAnalysis: '架构分析',
      content: '内容 Content：',
      organization: '组织 Organization：',
      grammar: '文法与句构 Grammar & Sentence Structure：',
      vocabulary: '字汇与拼字 Vocabulary & Spelling：',
      grammarSpellingAdvice: '文法与拼字建议',
      originalSentence: '原句：',
      revisionAdvice: '修改建议：',
      revisedSentence: '修正后句子：'
    },
    mic: {
      notAllowed: '请点击网址列左方的锁头图示，并允许存取麦克风。',
      notFound: '未侦测到麦克风装置，请确认设备已接上或使用其他设备。',
      notFoundShort: '未侦测到麦克风装置，请确认设备已接上。',
      notReadable: '麦克风可能被其他应用占用，请稍后再试。',
      security: '请使用 HTTPS 网站开启本功能。',
      default: '无法启用麦克风，请确认装置与浏览器设定。',
      unsupported: '此浏览器不支援麦克风功能，请使用 Chrome 或 Edge 开启。',
      initFailed: '录音元件初始化失败，请重新整理或更换浏览器。',
      initFailedShort: '录音元件初始化失败',
      startFailed: '无法启动录音，请确认麦克风权限与装置设定',
      startFailedShort: '无法启动录音',
      permissionDenied: '未授权麦克风，请至浏览器权限设定开启。',
      noDevice: '未侦测到麦克风装置，请使用其他设备或外接麦克风。'
    }
  },
  AiHome: {
    start: 'START',
    recent_route: {
      user_guide: '使用指南',
      letter_generate: '生成书信',
      speech_generate: '生成演讲稿',
      ai_correction: 'AI批改',
      business_context: '商业情境',
      daily_context: '生活情境'
    },
    conversation: {
      business_english: '商业英语会话',
      daily_english: '生活英语会话',
      monthly_topic: '每月精选主题',
      adults_free_talk: '成人自由口说',
      kids_free_talk: '儿童自由口说'
    },
    intro: {
      service_features: '服务特色',
      service_features_desc: 'AI 小助教整合先进 AI 语言处理技术，透过智能化演算法，协助您快速生成“商用书信”“英文演讲稿”，并提供 AI“口说练习”功能。无论是临时需要写一封英文 E-mail 给客户、准备下一场重要的英文演说，或利用零碎时间提升英语口说会话实力，AI 小助教都是您可搭配使用的辅助工具。',
      points_desc_title: '点数说明',
      points_desc: '本区采用点数制，依企业方案提供初始点数供学员体验 AI 服务，如点数使用完毕欢迎加购，以继续使用 AI 小助教各项服务。',
      guide: '使用说明',
      choose_type: '选择类型',
      choose_type_desc: '请在左侧选择您需要生成的内容',
      input_data: '输入资料',
      input_data_desc: '在指定栏位中以键盘输入或直接说出相关资讯，点击送出后，请稍作等待，由 AI 小助教为您完成目标任务。',
      view_result: '查看成果',
      view_result_desc: 'AI 小助教撰写完毕后，请再次阅读所生成内容是否符合所需，亦可依个人需求进行修改与调整。',
      more_features: '更多功能',
      more_features_desc: '欢迎点击字典查询、中文翻译、全文播放、AI 代答、更多说明等延伸功能进行进一步学习。若想获得更多灵感，请尝试重新生成，或选择不同情境，进行更多互动练习。'
    },
    common: {
      placeholder_answer: '请作答 ...',
      total_chars_pre: '共 ',
      total_chars_post: ' 字符',
      upload_image: '上传图片',
      start_correction: '开始批改',
      please_select: '请选择',
      speaking_practice: '口说练习',
      japanese_speaking_practice: '日语口说练习',
      deduct_points: '生成每次扣除：',
      edit_letter_info: '修改信件资讯',
      edit_speech_info: '修改演讲稿资讯',
      ph_disabled_summary: 'EX: 要诚挚邀请对方参与即将举行的商业会议，共同探讨机会，共创未来，会议时间在下个月13号。',
      confirm: '确认',
      return_edit: '返回修改',
      close: '关闭',
      clear: '清空',
      restart: '重新开始',
      on: '开',
      off: '关',
      cancel: '取消',
      audio_not_supported: '您的浏览器不支持音频播放。'
    },
    follow: {
      title: '跟读练习',
      input_hint: '请输入文字，以进行跟读练习',
      play_hint: '请点击“全文播放”聆听全文音档，或点击右侧麦克风进行逐句跟读练习',
      record: '记录',
      title_excellent: 'EXCELLENT 太棒了!',
      title_great: 'GREAT 很厉害',
      title_good: 'GOOD 不错喔',
      title_try_again: 'TRY AGAIN 再试一次',
      score_excellent: '很棒',
      score_good: '尚可',
      score_needs_improvement: '待加强',
      play_original: '原句播放',
      your_record: '你的录音'
    },
    correction: {
      result_title: 'AI批改结果',
      upload_hint: '请输入文字或点击下方上传图片按钮，将图片转为文字'
    },
    letter: {
      Letter: '商用书信',
      Sender_Information: '寄件人资讯',
      Sender_Name: '寄件人姓名',
      Sender_Company: '寄件人公司',
      Recipient_Information: '收件人资讯',
      Recipient_Name: '收件人姓名',
      Recipient_Company: '收件人公司',
      Letter_Information: '信件资讯',
      Subject: '信件主旨',
      Summary: '内容简述（100字以内）',
      required: '*此栏位必填',
      ph_s_name: 'e.g. Emily',
      ph_s_company: 'e.g. ABC公司',
      ph_r_name: 'e.g. David',
      ph_r_company: 'e.g. XYZ公司',
      ph_subject: 'e.g. 专案合作细节洽谈',
      ph_summary: 'e.g. 关于本次新产品专案合作细节，针对上市时程、合作细节、分润模式，希望能约贵公司下周进行当面会谈，以利双方业务推展。'
    },
    speech: {
      English_Speech_Script: '英文演讲稿',
      Speech_Information: '演讲资讯',
      Topic: '主题',
      Type: '类型',
      Audience: '对象',
      Occasion: '场合',
      Summary: '内容简述（100字以内）',
      ph_topic: 'e.g. 新产品介绍',
      ph_audience: 'e.g. 各大企业客户',
      type_meeting: '会议简报 Meeting Presentation',
      type_proposal: '企划提案 Project Proposal',
      type_motivational: '激励致词 Motivational Speech',
      type_knowledge: '知识分享 Knowledge Sharing',
      type_elevator: '电梯简报 Elevator Pitch',
      type_product: '产品示范 Product Demonstration',
      occ_internal: '内部专案会议 Internal Project Meeting',
      occ_external: '对外商务沟通 External Business Communication',
      occ_results: '成果发表与知识分享 Results Presentation and Knowledge Sharing',
      occ_motivation: '激励与其他资讯传达 Motivation and Other Information Delivery',
      ph_summary: 'e.g. 本次演讲将发表最新上市的 AI 产品,针对产品优势与特性说明,以协助各企业提升营运效率与创新竞争力。'
    },
    rule: {
      Total_Points: '目前总点数',
      Instructions: '操作说明',
      AI_Generation: 'AI 生成说明',
      AI_Review_Instructions: 'AI 批改说明',
      Note: '注意事项',
      Definition: '定义内容',
      privacy_and_security: '重视隐私与安全',
      review_again: '再次核对',
      per_letter_generation: '书信生成每次扣除',
      per_speech_generation: '演讲稿生成每次扣除',
      per_AI_generation: 'AI批改每次扣除',
      Friendly_Reminder: '温馨提醒',
      point: '点',
      letter: '书信',
      speech: '演讲稿',
      commercial_letter: '商用书信',
      letter_inst_desc: '请先填写寄件人与收件人资讯，再输入信件资讯。',
      letter_def_desc: 'AI 小助教生成后，您可依据实际使用需求，进一步针对细部书信内容调整。',
      letter_privacy_desc: '在输入资讯时，请谨慎不要透露自己或他人的个资或私人资讯。',
      letter_review_desc: '本篇商用书信为 AI 小助教自动生成，建议使用前再次斟酌核对相关细节。',
      speech_inst_desc: '请以中文填写“主题”与“对象”资讯，并点选“类型”与“场合”，再以中文填写“内容简述”说明演讲要点。',
      speech_gen_desc: '点击“START”按钮后，AI 将针对您的需求自动生成演讲稿。',
      speech_note_desc: '生成前请确认输入的文字内容，勿揭露公司与个人机密资讯。本演讲稿由 AI 自动生成，请自行核对确认相关内容。',
      correct_inst_desc: '请输入英文内容或点击下方“上传图片”按钮，并点选“开始批改”。',
      correct_review_desc: '点击“开始批改”按钮后，AI 将针对英文单字、文法、句构等进行检视，并提供“文法与词汇修正”与“整体回馈”建议。原文中若有错误的地方，将以红色显示，让您更容易发现问题并进行修正。AI 同时将自动依上传内容生成“AI 范文”，提供更多参考建议。',
      correct_note_desc: '批改前请确认输入的文字内容，勿揭露公司与个人机密资讯。本{type}由 AI 自动批改，请自行核对确认相关内容。',
      follow_mic: '请点选麦克风',
      follow_mic_desc: ' 开始录音。',
      follow_play: '请点选原句播放',
      follow_play_desc: '，聆听老师示范音档。',
      follow_my_record: '请点选我的录音',
      follow_my_record_desc: '，播放自己录制的音档。',
      follow_history: '请点选记录',
      follow_history_desc: '，查看个人录音练习记录。'
    },
    swal: {
      rules_title: '使用规范',
      got_it: '我知道了',
      current_points: '目前总点数：',
      points_desc: '本区依企业方案提供初始点数供您体验 AI 服务，<br/>每次使用以下服务将自动扣除点数。',
      speaking_practice: '口说练习：每次 1 点',
      business_letter: '商用书信：每次 20 点',
      speech_script: '英文演讲稿：每次 20 点',
      insufficient_points: '点数不足',
      confirm_generate: '确定开始生成{type}？',
      confirm_correct: '确定开始批改{type}？',
      current_points_html: '目前总点数 <span style="color: #F30000;">{points}</span> 点',
      deduct_20_points: '需扣除 20 点',
      points_after_html: '扣除后点数 <span style="color: #F30000;">{points}</span> 点',
      contact_cs: '请洽客服人员加购点数',
      generate_fail: '生成失败',
      generate_fail_msg: '糟糕！发生了一点小失误，请再给我一次机会！',
      translate_success: '翻译完成',
      system_error: '系统错误，请稍后再试',
      confirm_modify: '确定修改{type}资讯?',
      stay_on_page: '留在本页',
      practice_deduct_desc: '当进行 AI 口说练习，每次送出后随即扣除 1 点。',
      points_or_expired: '使用点数不足或时间过期',
      please_reinput: '请重新输入',
      tips_html_2: '口说练习每次扣除：<span class="text-red-main-ai">1</span> 点',
      tips_html_3: '操作说明：',
      tips_html_4: '1. 点{img1}说出回应的句子，再点{img2}，送出后随即扣点。',
      tips_html_5: '2. 点{img1}参考 AI 回应内容，并练习说说看。',
      tips_html_6: '3. 点{img1}输入想翻译的中文。',
      tips_html_7: '4. 点{img1}聆听自己的录音。',
      tips_html_8: '5. 点{img1}观看 AI 反馈建议，让自己下次说得更好。',
      tips_html_9: '6. 若 AI 回应不符预期，请修改文字内容或点击重新整理。',
      device_test: '设备测试',
      device_test_desc: '请对着麦克风说话，线条会随声音波动。<br/>若无反应，请确认麦克风权限已开启。'
    },
    result: {
      play_all: '全文播放',
      font_small: '字体变小',
      font_normal: '字体一般',
      font_large: '字体放大',
      translation: '中文翻译',
      dict_mode: '字典模式',
      download: '下载',
      tab_grammar: '文法与词汇修正',
      tab_feedback: '整体回馈',
      tab_sample: 'AI范文',
      shadowing: '跟读练习',
      grammar_advice_desc: '以下提供 {count} 项文法与词汇修正建议，希望能帮助你文法与用字更精准，以提升整体英文能力：',
      original_sentence: '原句：',
      suggestion: '建议：',
      explanation: '说明：',
      salutation: '开头称谓：',
      body: '信件本文：',
      closing: '结尾敬语与署名：',
      overall_feedback: '整体回馈：',
      copy_success: '复制成功',
      copy_fail: '发生错误'
    },
    chat: {
      chinese_input: '中文输入',
      ai_suggest: 'AI代答',
      placeholder_active: '请点“麦克风”开始录音应答，或点“AI”生成回应建议。',
      placeholder_disabled: '对话记录仅供资料查看',
      submit: '送出',
      choose_topic: '请选择主题，来场零压力的互动对话练习吧！',
      speaking_practice: '口说练习',
      what_to_do_in_topic: '你想在 {topic} 做什么呢？',
      scenario_shadowing: '情境跟读练习',
      scenario_conversation: '情境对话练习',
      scenario_selection: '情境选择',
      chinese_translation: '中文翻译',
      you_have_selected: '你已选择：',
      start_conversation_practice: '开始对话练习',
      start_stop_record: '开始/停止录音',
      accent_us: '美国口音',
      accent_uk: '英国口音',
      accent_au: '澳洲口音',
      accent_in: '印度口音',
      play_audio: '播放原音',
      my_recording: '我的录音',
      more_explanation: '更多说明',
      in_other_words: '换句话说',
      refresh: '重新整理',
      ph_translate_input: '请在此输入您想翻译的中文。',
      playback_speed: '播放速度',
      speed: '语速',
      text_display: '文字显示',
      show_subtitle: '显示字幕',
      hide_subtitle: '字幕关闭',
      save_settings: '储存设定',
      chat_settings: '聊天设定',
      save_confirm_title: '储存确认',
      save_confirm_msg: '请问您是否要储存本次对话记录，对话记录储存后可以再次开启对话进行练习，并且观看本次对话成果。',
      save_note: '备注：每组对话记录为唯一资料，若您想要以相同的对话主题，进行不同的口说练习，请按重新开始，开启新的对话。',
      save_success: '储存成功',
      view_records_score: '查看记录评分',
      continue_chatting: '继续聊天',
      history_title: '我的对话记录',
      rating_title: '我的对话评分',
      time: '时间',
      scene: '场景',
      topic: '主题',
      first_saved_at: '第一次储存时间',
      last_updated_at: '最近一次更新',
      updated_at: '更新时间',
      scene_topic: '场景主题',
      function: '功能',
      sentence_score: '单句分数',
      chat_content: '聊天内容',
      continue_conversation: '继续对话',
      sample_scene_topic: '机场>查询航班',
      sample_voice_setting: '女声 / 英国腔'
    },
    ocr: {
      popup_title: '图片转文字',
      step1: '选取与上传',
      step2: '裁切图片',
      step3: '开始辨识',
      step4: '辨识修正',
      upload_drag_hint: '拖移档案到框内，或点选按钮开启资料夹上传图片',
      upload_limit_hint: '档案需小于 10MB，图片长宽像素必须小于 10000px',
      btn_upload: '上传图片',
      btn_reupload: '重新上传图片',
      btn_confirm_submit: '确认并送出',
      btn_confirm_text: '确认文字',
      btn_input_submit: '输入',
      err_not_image: '请选择图片档案（例如 .jpg、.png）',
      err_size_limit: '档案大小不能超过 10MB',
      err_pixel_limit: '图片尺寸不能超过 10000 像素',
      crop_guide_hint: '拖移边框确认需裁切的图片范围',
      recognizing_hint: '辨识中，请稍后……',
      recognition_complete: '辨识完成！',
      recognition_fail_hint: '辨识失败，请重新检视图片格式（小于 10MB）与图片像素（长宽低于 10000px）是否符合相关上传规定。',
      edit_hint: '可点选文字内容进行修正',
      recognition_warning_hint: 'AI 辨识文字结果会因字迹整齐、纸张整洁或照片清晰度之影响而有所不同，请务必重新检视一遍并进行修正再确认上传文章。'
    }
  },
  Course: {
    Description_video: '讲解',
    Interactive_learning: '互动学习',
    Unit_test: '单元测验'
  },
  Personal: {
    PersonalArea: '个人专区',
    Info: {
      Total_study_time: '学习时数',
      Number_of_courses_passed: '通过课数',
      Number_of_monthly_exams: '月考次数',
      First_time_login: '首次登入'
    },
    Target: {
      Target: '学习目标',
      Goal: '目标',
      Result: '结果',
      Completed: '已完成',
      Unit: '课',
      Points: '分',
      Time: '次'
    },
    Record: {
      Learning_records: '学习纪录',
      View_all: '总览',
      Date_settings: '日期区间',
      Learning_hours: '学习时数',
      Number_of_completed_courses: '完成课数',
      Number_of_unit_tests_passed: '通过课后挑战数',
      Details: '详细内容',
      Course_categories: '课程分类',
      History: '最近学习时间',
      Unit_test_score: '单元测验分数',
      Go_to_course: '前往课程',
      Writing: '写作纪录'
    },
    Collection: {
      Collection: '收藏',
      Vocabulary: '单字',
      Lesson: '课程'
    },
    Exam: {
      ExamArea: '测验专区',
      Placement_test: '学前测验',
      Result: '分级结果',
      Exam_date: '测验日期',
      Answering_time: '作答时间',
      Listening_score: '听力成绩',
      Reading_score: '阅读成绩',
      Total_score: '总分',
      Monthly_mock_test: '每月模考',
      More_practice: '更多练习',
      Updated_exam_date: '最近测验日期',
      Number_of_exercises: '练习次数',
      Start: '开始',
      Details: '详解'
    }
  }
}
